import {Trans} from '@lingui/macro';
import React, {FC, ReactNode} from 'react';

import {TextBox} from '../../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {ServerEditorStateActions} from '../../../editors/serverEditor/useServerEditorState';

/*
 * Props.
 */

interface ServerOriginInputProps {
  origin: string;
  onUpdate: ServerEditorStateActions['onUpdateOrigin'];
  isReadOnly: boolean;
  additionalLabelInfo?: ReactNode;
}

/*
 * Component.
 */

export const ServerOriginInput: FC<ServerOriginInputProps> = (props) => {
  const {origin, onUpdate, isReadOnly, additionalLabelInfo} = props;

  return (
    <TextBox
      value={origin}
      onChange={onUpdate}
      size={VisualSizesEnum.LARGE}
      noMargin
      label={<Trans id="server-editor-origin-label">Origin</Trans>}
      additionalLabelInfo={additionalLabelInfo}
      placeholder="https://backoffice.company.com/api"
      isDisabled={isReadOnly}
    />
  );
};
